import * as exp from "constants";

export enum GridName {
    LEADS = "leads",
    COMPANIES = "companies",
    CUSTOMERS = "customers",
    PROSPECTS = "prospects",
    CONTACTS = "contacts",
    VENDORLISTS = 'vendor-list',
    VENDORCONTACTS = 'vendor-contact',
    REQUIREMENTS = "requirements",
    COMPANYRECYCLE = "company-recycle-bin",
    CODECROSSWALK = "code-crosswalk",
    CONTACTRECYCLE = "contact-recycle-bin",
    ARCHIVED = "archivedCompanies",
    CERTIFICATION = "Certification",
    PARTLIST = "parts-list",
    INSTOCK = 'instock',
    ALLOCATION = 'allocation',
    CONSIGNMENT = 'consignment',
    PENDING = 'pending',
    QUARANTINE = 'quarantine',
    DOCUMENT = "document",
    HISTORY = "history",
    AG_GRID_PAGINATIONMODEL = 'agGridPaginationModel',
    SOLD ="Sold",
    SOURCING = "Sourcing",
    SOURCING_BATCH_OVERVIEW = "Sourcing-Batch-Overview",
    SEND_TO_SOURCING_REQUIREMENT = "Send-to-sourcing-requirement",
    SEND_TO_SOURCING_SOURCING = "Send-to-sourcing-sourcing",
    SOURCING_REQUIREMENT = "Sourcing-requirement",
    OFFERS ="Offers",
    OEM_EXCESS ="OEM-Excess",
    VENDOR_PARTS ="Vendor-parts",
    OEM_EXCESS_MANAGER ="OEM-Excess-Manager",
    REQUEST_VENDOR ="Request Vendor",
    CONFIRM_SELECTION ="Confirm Selection",
    SEND_REQUEST="Send Request",
    UNMAPPED_COLUMNS = 'Unmapped Headers',
    VENDOR_PARTS_LIST ="Vendor-parts-list",


    INVENTORY_CATEGORIES = 'inventory categories',


    ALTERNATIVES ="Alternatives",
    REQUIREMNT="Requirements",
    LINEINFORMATION="Line-Information",
    IMAGES="Images",
    VIEWLINEINFORMATION="View-Line-Information",
  LINEHISORTY = "Line-History",
  LINE_ALLOCATION = "Allocations",
  VENDOR_PARTS_LIBRARY = "Vendor-parts-library",
  WORKORDER = 'work-order',
  FILES = "files",
  RELATED_REQUIREMENT = "related-reuirement",
  AG_GRID_PARTLIST_PAGINATIONMODEL='AG_GRID_PARTLIST_PAGINATIONMODEL',
  AG_GRID_VPL_PAGINATIONMODEL='AG_GRID_VPL_PAGINATIONMODEL',
  AG_GRID_OEM_PAGINATIONMODEL='AG_GRID_OEM_PAGINATIONMODEL',
  AG_GRID_SOURCING_PAGINATIONMODEL='AG_GRID_SOURCING_PAGINATIONMODEL',
  AG_GRID_SOURCE_VENDOR_PAGINATIONMODEL='AG_GRID_SOURCE_VENDOR_PAGINATIONMODEL',
  AG_GRID_SOURCE_MSV_PAGINATIONMODEL='AG_GRID_SOURCE_MSV_PAGINATIONMODEL',
  AG_GRID_STS_REQUIREMENT_PAGINATIONMODEL='AG_GRID_STS_REQUIREMENT_PAGINATIONMODEL',
  AG_GRID_STS_SOURCING_PAGINATIONMODEL='AG_GRID_STS_SOURCING_PAGINATIONMODEL',
  RMA = "RMA",
  RTV = "RTV",
  NCM = "NCM",
  INSPECTION = "INSPECTION",
  QUOTES = "QUOTES",
  SALESORDERS = "SALESORDERS",
  PURCHASEORDERS = "PURCHASEORDERS",
  INVOICES = "INVOICES",
  REQUIREMENT_SOURCES_GRID="REQUIREMENT_SOURCES_GRID",
  REQUIREMENT_AVAILABLE_GRID="REQUIREMENT_AVAILABLE_GRID",
  REQUIREMENT_POTENTIAL_GRID="REQUIREMENT_POTENTIAL_GRID",
  SOURCING_AVAILABLE_GRID="SOURCING_AVAILABLE_GRID",
  SOURCING_BATCH_OVERVIEW_GRID="SOURCING_BATCH_OVERVIEW_GRID",
  SOURCING_POTENTIAL_GRID="SOURCING_POTENTIAL_GRID",
  SOURCING_VENDOR_GRID="SOURCING_VENDOR_GRID",
  SOURCING_MSV_GRID="SOURCING_MSV_GRID",
  REQUIREMENT_REVIEW_GRID="REQUIREMENT_REVIEW_GRID",
  RFQS_SENT_GRID="RFQS_SENT_GRID",
  SOURCING_REVIEW_GRID="SOURCING_REVIEW_GRID",
  SOURCING_SEND_RFQS_GRID="SOURCING_SEND_RFQS_GRID",
  RFQS_RESULT_GRID="RFQS_RESULT_GRID",
}

  export enum AggridHeadername {
    COMPANIES = "Company",
    VENDOR_NAME = "Vendor Name",
    STAGE     = "Stage",
    CONTACT_NAME = "Contact Name",
    CONTACT_COMPANY_NAME = "company",
    PHONE = "Phone",
    SALESPERSON = "Salesperson",
    COMPANY_EMAIL = "Company Email",
    DANDB = "D&B Number",
    MAIN_CONTACT =     "Main Contact",
    EMAIL    = "Email",
    TYPE = "Type",
    DATE_CONTACTED    = "Date Contacted",
    RATING = "Rating",
    ACTIVE =  "Active",
    FAX = "Fax",
    WEBSITE = "Website",
    EMPLOYEES   = "Employees",
    TIMEZONE  = "Timezone",
    INDUSTRY  = "Industry",
    SIC  = "SIC",
    NAICS    = "NAICS",
    COUNTRY   = "Country",
    DO_NOT_CALL =  "Do Not Call",
    DO_NOT_EMAIL =  "Do Not Email",
    REVENUE  = "Revenue",
    ALTERNATE_SALESPERSON = "Alternate Salesperson",
    QUICK_NOTES =   "Quick Notes",
    ACCOUNT_NUMBER  = "Account number",
    CURRENCY   = "Currency",
    SOURCING_EMAIL =   "Sourcing Email",
    ACCOUNTING_CONTACT =   "Accounting Contact",
    SALES_12_MONTHS     = "Sales 12 months",
    STATE = "State",
    LEAD_SCORE = "Lead Score",
    INTENT_TO_BUY =  "Intent to Buy",
    DEPARTMENT =  "Department",
    TITLE     = "Title",
    LOCATION           = "Location",
    MAIN_OFFICE_NUMBER     =  "Main Office Number",
    EMAIL_ADDRESS  = "Email Address",
    SKYPE  = "Skype",
    XING     = "Xing",
    LINKEDIN  = "LinkedIn",
    VENDOR_TYPE = "Vendor Type",
    AVL   = "AVL",
    GENERAL_EMAIL    =  "General Email",
    PRIMARY_CONTACT_NAME = "Primary Contact Name",
    PRIMARY_CONTACT_EMAIL   = "Primary Contact Email",
    PRIMARY_CONTACT_PHONE =    "Primary Contact Phone",
    ACCOUNTING_CONTACT_NAME          = "Accounting Contact Name",
    ACCOUNTING_CONTACT_EMAIL_ADDRESS        = "Accounting Contact Email Address",
    PARENT_COMPANY            = "Parent Company ",
    ENTITY_TYPE =   "Entity Type",
    BUYERS_REP =  "Buyer's Rep",
    GENDER = "Gender",
    MOBILE_NUMBER   = "Mobile Number",
    DIRECT_NUMBER    = "Direct Number",
    MAIN_OFFICE_NUMBER_EXTENSION =      "Main Office Number + Extension",
    MARK_AS_PRIMARY =     "Mark As Primary",
    PRIMARY =  "Primary",
    MARK_AS_ACCOUNTING    = "Mark As Accounting",
    ACCOUNTING =   "Accounting",
    NEXT_TASK_DUE_DATE = "Next Task Due Date",
    LAST_CONTACT    = "Last Contact",
    SIC_CODE    = "SIC Code",
    SIC_DESCRIPTION      = "SIC Description",
    NAICS_CODE = "NAICS Code",
    NAICS_DESCRIPTION        = "NAICS Description",
    NAICS_YEAR =       "NAICS Year",
    REQ_NO = "Req No",
    MPN = "MPN",
    MFR = "MFR",
    CPN = "CPN",
    QUANTITY = "Quantity",
    SOURCE = "Source",
    CUSTOMER = "Customer",
    DATE_CODE = "Date Code",
    APPROVED = "Approved",
    AVAILABLE = "Available",
    POTENTIAL = "Potential",
    LINE_STATUS = "Line Status",
    REQUIREMENT_NO = "Requirement No"
  }  


  export enum  HistoryHeader {
    MESSAGE  = "Message",
    ACTION =   "Action",
    BY       = "By",
    DATE     = " Date",
  }

  export enum DocumentTabHeader {
     FILE_NAME =    "File Name",
     FILE_TYPE =    "Type",
     SIZE  = "Size",
     CATEGORY    = "Category",
     SOURCE =  "Source",
     DATE_UPLOADED     = "Date Uploaded",
  }

  export enum CertificationTabHeader {
    CERTIFICATION_NAME  = "Certification Name",
    DATE_ISSUED   = "Date Issued",
    EXPIRATION_DATE =  "Expiration Date",
    FILE_NAME =   "File Name",
    EXPIRED   = "Expired",
    ACTIONS =   "Actions"
  }

  export enum PartandInventoryHeader {
   MPN =    "MPN",
   MFR =    "MFR",
   ON_HAND =     "On Hand",
   AVAILABLE =    "Available",
   ALLOCATED =   "Allocated",
   Consignment    = "Consignment",
   PENDING =   "Pending",
   QUARANTINE   = "Quarantine",
   OFFERS   = "Offers",
   OEM_EXCESS =  "OEM Excess",
  }

  export enum InventoryCategoriesHeader {
    INVENTORY_CATEGORIES = "Inventory Categories",
   }

  //  REQUIRMENT ENUM 

  export enum RequirementHeader {
    REQUIREMENT_NUMBER    = "Requirement Number",
    REQ_DATE   = "Req Date",
    BUY_TARGET =  "Buy Target",
    STATUS =    "Status",
    PART_NUMBER   = "Part Number",
    DATE_YEAR  = "Date Code Year",
    DATE_WEEK = "Date Code Week",
    TARGET_PRICE =  "Target Price",
    SALESPERSON  =  "Salesperson",
    QTY   = "Qty",
    CONDITION = "Condition",
    COMMENTS = "Comments",
    CUST_RFQ_NO = "Cust RFQ No",
    NEED_DATE = "Need Date",
    ENTERED_BY = "Entered By"

  }


  //   PART AND Inventory  Enum 

  export enum HeaderName {
   PART_NUMBER      = "Part Number",
   MFR =   "Mfr",
   ONHAND    = "On Hand",
   AVAILABLE = "Available",
   DATE_CODE =  "Date Code",
   LOT_CODE =    "Lot Code",
   SPQ    = "SPQ",
   ITEM_PKG  = "Standard Pkg",
   ROHS =   "RoHS",
   VENDOR =   "Vendor",
   ALLOCATED_QTY = "Allocated Qty",
   ALLOCATED_DATE = "Allocated Date",
   CONDITION = "Condition",
   SO_NO = "SO No",
   CUSTOMER = "Customer",
   WAREHOUSE = "Warehouse",
   LOCATION = "Location",
   CONISIGNED_QTY = 'Consigned Qty',
   CONSIGNOR = 'Consignor',
   STATUS = "Status",
   WO_NO = 'WO No',
   NCM =  'NCM',
   QTY = 'Qty',
   MPN = 'MPN',
   REASON = 'Reason',
   TESTHOUSE = 'Testhouse',
   CONTACT = 'Contact',
   INVOICE = 'Invoice No',
   CUSTOMER_PO = 'Customer PO',
   DATE_OFFERED = 'Date Offered',
   OFFER_QTY = 'Offer Qty',
   OFFER_SCORE = 'Offer Score',
   AVAILABLE_QTY = 'Available Qty',
   TESTING = 'Testing',
   LIST_DATE='List Date',
   CPN = 'CPN',
   COSTOMER_CONTACT = 'Customer Contact',
   RECORD_TYPE = 'Record Type',
   QTY_AVAILABLE= 'Qty Available',
   PRICE = 'Price',
   RATING = 'Rating',
   ACTIVE = 'Active',
   EXPIRATION_DATE='Expiration Date',
   VENDOR_CONTACT ='Vendor Contact',
   MANUFACTURER ='Manufacturer',
   DESCRIPTION ='Description',
   PART_STATUS ='Part Status',
   TAGS ='Tags',
   DEVICE_PKG ='Device Pkg',
   STANDARD_PKG ='Standard Pkg',
   COO ='COO',
   NOTES ='Notes',
  COMPANY ="Company",
  COMPANYNAME= "Company Name",
  WORKORDERID= "Work Order ID",
  STATUSID= "Status ID",
  STATUSNAME= "Status Name",
  COMPANYID= "Company ID",
  CUSTOMERID= "Customer ID",
  EVENT= "Event",
  ACTION= "Action",
  BY= "By",
  TIME= "Time",
  DATE= "Date",
  }

  export enum importHeaders {
    SYSTEM_COLUMNS    =  "System Columns",
    MAP_TO = "Map to",
    STATUS = "Status",
    COMPANY_NAME = "Compnay Name",
    STAGE = "Stage",
    TYPE = "Type",
    SALESPERSON = "Salesperson",
    COUNTRY = "Country",
    ALTERNATE_SALESPERSON = "Alternate Salesperson",

    //  erros tabs 

    ROW_NO  = "Row No",
    ERROR_FIELD = "Error Field",
    ERROR_DATA = "Error Data",
    CORRECT_FIELD = "Correct Field",
    ERROR_MESSAGE = "Error Message",
  }

  export enum StorageName {
    CRM_COMPANIES_GRID = "CRM_COMPANIES_GRID",
    CRM_CONTACT_GRID = "CRM_CONTACT_GRID",
    CRM_LEADS_GRID = "CRM_LEADS_GRID",
    CRM_PROSPECTS_GRID = "CRM_PROSPECTS_GRID",
    CRM_CUSTOMER_GRID = "CRM_CUSTOMER_GRID",
    CRM_COMPANY_ARCHIVED_GRID = 'CRM_COMPANY_ARCHIVED_GRID',
    SALES_REQUIREMENT_GRID = 'SALES_REQUIREMENT_GRID',
    PROCUREMENT_VENDORLIST  = "PROCUREMENT_VENDORLIST",
    PROCUREMENT_SOURCING  = "PROCUREMENT_SOURCING",
    PROCUREMENT_SOURCING_REQUIREMENT  = "PROCUREMENT_SOURCING_REQUIREMENT",
    PROCUREMENT_VENDORCONTACTLIST = "PROCUREMENT_VENDORCONTACTLIST",
    ADMIN_CODE_CROSSWALK  = "ADMIN_CODE_CROSSWALK",
    ADMIN_COMPANY_RECYCLEBIN =  "ADMIN_COMPANY_RECYCLEBIN",
    ADMIN_CONTACT_RECYCLEBIN = "ADMIN_CONTACT_RECYCLEBIN",
    COMPANY_HISTORY = "COMPANY_HISTORY",
    COMPANY_DOCUMENT = "COMPANY_DOCUMENT",
    COMPANY_CERTIFICATE = "COMPANY_CERTIFICATE",
    PART_LIST_GRID = "PART_LIST_GRID",
    INVENTORYCATEGORIES_GRID = "INVENTORYCATEGORIES_GRID",
    SOURCING_GRID = "SOURCING_GRID",
    SOURCING_VENDOR_GRID = "SOURCING_VENDOR_GRID",
    RELATED_REQUIREMENT_GRID="RELATED_REQUIREMENT_GRID",
    RFQ_RESULT_GRID="RFQ_RESULT_GRID",
  } 
